
    var riot = require('riot')
    //src: starling/src/tags/node-limit-upsell-banner.html
riot.tag2('node-limit-upsell-banner',
  '<svg><use xlink:href="#plectica-pro-icon"></use></svg> <span> <div class="heading">You\'re mapping your ideas like an expert!</div> <span class="sub-heading">You\'ve used {this.usui.nodeCount} of 250 free cards, upgrade to Plectica Pro for unlimited cards.</span> <a class="learn-more" href="/pricing?banner=node-limit" target="_blank">Learn more</a> </span> <span onclick="{showPaymentModal}" class="call-to-action"> Get unlimited cards </span> <i class="dismiss material-icons" onclick="{this.dismiss}">close</i>',
  '',
  'show="{this.usui.upsellBannerShowing}"', function(opts) {
'use strict';

var _upsellUi = require('lib/upsell-ui');

this.usui = _upsellUi.usui;

this.usui.bannerTag = this;

this.dismiss = function () {
  _upsellUi.usui.dismissUpsellBanner();
};

this.showPaymentModal = function () {
  _upsellUi.usui.showPaymentModal();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-limit-upsell-banner')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-limit-upsell-banner.html
// module id = 747
// module chunks = 0